/**
 * Conditional
 */

class Conditional {
  static or( ...args ) {
    for ( const item in args ) {
      if ( args[ item ] ) {
        return args[ item ];
      }
    }

    return '';
  }

  static and( ...args ) {
    for ( const item in args ) {
      if ( !args[ item ] ) {
        return '';
      }
    }

    return args[ args.length - 1 ];
  }
}

export default Conditional;
